import {
  Col,
  Container,
  Card,
  CardBody,
  Row,
  FormGroup,
  Label,
} from "reactstrap";
import { Btn } from "../../AbstractElements";
import { Epin, SearchPinTital } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import DatePicker from "react-datepicker";
import { useEffect, useState, useRef } from "react";
import { decryptData } from "../../utils/helper/Crypto";
import * as XLSX from "xlsx";
import { format } from "date-fns";
import { IoMdPrint } from "react-icons/io";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import DataTable from "react-data-table-component";
import { useCommonService } from "../../Service/CommonService/Commonservice";
import { useSweetAlert } from "../../Context/SweetAlertContext";
import Datanotfound from "../PageNotFound/Datanotfound";
import CustomPagination from "../CustomPagination";
import { IoSearchSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "./Searchpin.scss";
import { EPinService } from "../../Service/EPin/EPinService";
const SearchPinReport = () => {
  const { showAlert, ShowSuccessAlert } = useSweetAlert();
  const { ApiCalling, ExecuteProcedure } = useCommonService(); // ✅ Add this line to use the new service

  const { getActivePinData, loading: activePinLoading } = EPinService();

  const navigator = useNavigate();
  ///-------------------------------------search report part-----------------------------------------------

  const [data, setData] = useState<any>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [fromDate, setFromDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30); // Default 30 days ago
    return date;
  });

  const [toDate, setToDate] = useState(new Date());
  const [filterText, setFilterText] = useState("");
  const [columns, setColumns] = useState<any[]>([]);

  const [cols, setCols] = useState<any[]>(() => columns); // ✅ NOT [columns]

  // first column ko fixed width do
  useEffect(() => {
    setCols(() =>
      columns.map((c, i) =>
        i === 1
          ? { ...c, width: "50px", minWidth: "50px", maxWidth: "50px", grow: 0 }
          : c
      )
    );
  }, [columns]);
  const heightOffset = 120;
  const [loading, setLoading] = useState(false);
  const [memberID, setmemberID] = useState(
    decryptData(localStorage.getItem("clientId") as string)
  );

  const [searchBy, setSearchBy] = useState("PIN");
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("Unused");
  const [packageId, setPackageId] = useState("");
  const [unUsedPin, setunUsedPin] = useState(0);
  const [usedPin, setusedPin] = useState(0);
  const [totalPin, settotalPin] = useState(0);
  const [activePin, setactivePin] = useState<any[]>([]);
  // const [packages, setPackages] = useState<any[]>([]);

  const GetBoxData = async () => {
    const param = {
      AllotedTo: memberID,
      ActionMode: "SelectPinData",
    };
    const obj = {
      procName: "MemberPin",
      Para: JSON.stringify(param),
    };
    const result = await ExecuteProcedure(obj);
    if (Array.isArray(result)) {
      setunUsedPin(result[0].UnUsedPin);
      setusedPin(result[0].UsedPin);
      settotalPin(result[0].TotalPin);
    } else {
      setunUsedPin(0);
      setusedPin(0);
      settotalPin(0);
    }
  }; // ✅ Add this new function to fetch the dynamic data using the service
  const fetchDynamicActivePins = async () => {
    const payload = {
      procName: "MemberPin",
      Para: JSON.stringify({
        AllotedTo: memberID,
        ActionMode: "SelectActivePinData",
      }),
    };
    try {
      const result = await getActivePinData(payload);
      if (Array.isArray(result) && result.length > 0) {
        setactivePin(result);
      } else {
        setactivePin([]);
      }
    } catch (error) {
      console.error("Failed to fetch dynamic active pins:", error);
      setactivePin([]); // Ensure state is reset on error
    }
  };

  // const fetchPackages = async () => {
  //   const payload = {
  //     procName: "MemberPin",
  //     Para: JSON.stringify({
  //       AllotedTo: memberID,
  //       ActionMode: "SelectActivePinData", // <-- Your backend must support this
  //     }),
  //   };

  //   try {
  //     const result = await ApiCalling(payload);
  //     if (Array.isArray(result) && result.length > 0) {
  //       setPackages(result);
  //     } else {
  //       setPackages([]);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch packages:", error);
  //     setPackages([]);
  //   }
  // };

  useEffect(() => {
    GetBoxData();
    fetchDynamicActivePins();
    // fetchPackages();
  }, []);

  // this is your function
  useEffect(() => {
    // attach to window so inline onclick can see it
    (window as any).handleAction = (type: string) => {
      if (type === "LevelIncome") {
        console.log("Go to LevelIncomeReport");
        navigator(`${import.meta.env.BASE_URL}/` + type);
      } else if (type === "RewardIncome") {
        navigator(`${import.meta.env.BASE_URL}/` + type);
        console.log("Go to RewardIncomeReport");
      }
    };
  }, []);

  // ✅ Unified Data Fetcher
  const FetchData = async (
    page = currentPage,
    size = perPage,
    search = filterText
  ) => {
    setLoading(true);

    const formattedFromDate = format(fromDate, "dd-MMMM-yyyy");
    const formattedToDate = format(toDate, "dd-MMMM-yyyy");

    const obj = {
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
      page,
      size,
      AllotedTo: memberID,
      SearchBy: searchBy,
      Value: value,
      Type: "All",
      Status: status,
      PackageId: packageId,
      ActionMode: "ReactSearch",
    };

    const param = {
      procName: "MemberPin",
      Para: JSON.stringify(obj),
    };

    try {
      const res = await ApiCalling(param);

      if (Array.isArray(res) && res.length > 0) {
        // Remove TotalCount column from each object
        const cleanedData = res.map(({ TotalCount, ...rest }) => rest);

        //const keys = Object.keys(res[0] || {});
        const keys = Object.keys(cleanedData[0]);

        const list = keys.map((col) => ({
          name: col,
          selector: (row: any) => row[col],
          sortable: true,
          center: false,
          width: "auto",
          cell: (row: any) => (
            <div dangerouslySetInnerHTML={{ __html: row[col] }} />
          ),
        }));

        setColumns(list);
        setData(cleanedData);
        const total = res[0]?.TotalCount ?? 0;
        setTotalRows(total); // ✅ important
      } else {
        setColumns([]);
        setData([]);
        setTotalRows(0);
      }
      refload.current = false;
    } catch (error) {
      console.error("Data fetch failed:", error);
    }

    setLoading(false);
  };

  // ✅ Search (onSubmit of form)
  const handleSubmit = (e: any) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to first page
    FetchData(1, perPage, filterText); // Pulls fresh data
  };
  const refload = useRef(false);
  useEffect(() => {
    if (!refload.current) {
      console.log("Effect triggered with", currentPage, perPage);
      refload.current = true;
      FetchData(currentPage, perPage, filterText);
    }
  }, [currentPage, perPage, filterText]);

  const exportAndPrintCSV = (data: any) => {
    if (data.length === 0) {
      showAlert("Oops!", "No data available at the moment.");
      return;
    }

    // Clean data and convert to CSV format
    const cleanedData = cleanDataForExport(data);
    const csvData = XLSX.utils.sheet_to_csv(
      XLSX.utils.json_to_sheet(cleanedData)
    );

    // Convert CSV data to an HTML table and print
    printCSVData(csvData);
  };
  // Function to convert CSV to HTML table and print
  const printCSVData = (csvData: string) => {
    const escapeHtml = (text: string) =>
      text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    const rows = csvData
      .split("\n")
      .map((row) => row.split(","))
      .filter(
        (row) => row.length > 1 && row.some((cell) => cell.trim() !== "")
      );

    if (rows.length === 0) {
      alert("No valid data to print.");
      return;
    }

    const printWindow = window.open("", "", "height=900,width=1200");
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
      <head>
        <title>Printable Report</title>
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 20px; 
            padding: 0;
            color: #333;
          }
          h2 {
            text-align: center;
            margin-bottom: 20px;
          }
          table { 
            width: 100%; 
            border-collapse: collapse; 
            font-size: 12px; 
          }
          th, td { 
            border: 1px solid #ddd; 
            padding: 6px; 
            text-align: left; 
          }
          th { 
            background-color: #f2f2f2; 
            font-weight: bold; 
          }
          td { 
            white-space: pre-wrap; 
            word-break: break-word;
          }
          @media print {
            body { margin: 10mm; }
            button { display: none; }
          }
        </style>
      </head>
      <body>
        <h2>Report</h2>
        <table>
          <thead>
            <tr>
              ${rows[0]
                .map((cell) => `<th>${escapeHtml(cell.trim())}</th>`)
                .join("")}
            </tr>
          </thead>
          <tbody>
            ${rows
              .slice(1)
              .map(
                (row) => `
              <tr>
                ${row
                  .map((cell) => `<td>${escapeHtml(cell.trim())}</td>`)
                  .join("")}
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          };
        </script>
      </body>
      </html>
    `);
      printWindow.document.close();
      printWindow.focus();
    } else {
      console.error("Failed to open print window.");
    }
  };

  const cleanDataForExport = (data: any[]) => {
    return data.map((row) => {
      const cleanedRow: any = {};
      for (let key in row) {
        if (typeof row[key] === "string") {
          const div = document.createElement("div");
          div.innerHTML = row[key];
          const inputElement = div.querySelector("input");
          if (inputElement) {
            // Get the value of the input field
            cleanedRow[key] = inputElement.value || "";
          } else {
            cleanedRow[key] = div.textContent || div.innerText || "";
          }
        } else {
          cleanedRow[key] = row[key];
        }
      }
      return cleanedRow;
    });
  };

  const exportToExcel = (data: any) => {
    if (data.length === 0) {
      showAlert("Opps!", "No data available at the moment.");
      return;
    }

    // Clean data to remove HTML tags
    const cleanedData = cleanDataForExport(data);

    // Convert cleaned data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, "TableData.xlsx");
  };

  const navigate = useNavigate();

  (window as any).Registration = (pin: string) => {
    localStorage.setItem("selectedPin", pin);
    navigate(`${import.meta.env.BASE_URL}/registerxyz`, { state: { pin } });
  };

  (window as any).UpgradeMember = (pin: string) => {
    localStorage.setItem("selectedPin", pin);
    navigate(`${import.meta.env.BASE_URL}/UpgradeMember`, {
      state: { pin },
    });
  };

  (window as any).TransferPin = (pin: string) => {
    localStorage.setItem("selectedPin", pin);
    navigate(`${import.meta.env.BASE_URL}/transferepinForm`, {
      state: { pin },
    });
  };

  return (
    <>
      <style>
        {`
        .rdt_TableHeadRow [data-column-id="2"] {
          width: 185px !important;
          }
          #cell-2-undefined {
            min-width: 185px !important;
            width: 800px !important;
          }
        `}
      </style>

      <div className="page-body">
        <Breadcrumbs
          mainTitle={SearchPinTital}
          parent={Epin}
          ChildName={SearchPinTital}
        />
        <Container fluid className="innerPageCard">
          <div className="income-row">
            <div className="income-card border-orange">
              {" "}
              <div className="w-100">
                <h6 className="income-title">Active E-Pins</h6>{" "}
                {/* ✅ Conditional rendering based on the activePin state */}{" "}
                {activePin.length > 0 ? (
                  activePin.map((pin, index) => (
                    <div className="d-flex justify-content-between" key={index}>
                      {" "}
                      <span className="font-size-15" style={{ color: "black" }}>
                        {pin.ProductName}{" "}
                      </span>{" "}
                      <span className="font-size-16">{pin.ProductCount} </span>{" "}
                    </div>
                  ))
                ) : (
                  <div className="d-flex justify-content-between">
                    {" "}
                    <span className="font-size-15" style={{ color: "black" }}>
                      No Active E-Pins{" "}
                    </span>{" "}
                    <span className="font-size-16"> 0 </span>{" "}
                  </div>
                )}{" "}
              </div>
            </div>
            <div className="income-card border-blue">
              <div>
                <h6 className="income-title">Un-Used E-Pins</h6>
                <div className="income-body">
                  <span className="income-value">{unUsedPin}</span>
                  <span className="income-icon mdi mdi-account-multiple"></span>
                </div>
              </div>
              <div className="right-img">
                <Image
                  src={dynamicImage("Icons/incomeIcon.png")}
                  alt="plus"
                  className="me-2"
                />
              </div>
            </div>

            <div className="income-card border-blue">
              <div>
                <h6 className="income-title">Used E-Pins</h6>
                <div className="income-body">
                  <span className="income-value">{usedPin}</span>
                  <span className="income-icon mdi mdi-account-multiple"></span>
                </div>
              </div>
              <div className="right-img">
                <Image
                  src={dynamicImage("Icons/incomeIcon.png")}
                  alt="plus"
                  className="me-2"
                />
              </div>
            </div>

            <div className="income-card border-orange">
              <div>
                <h6 className="income-title">Total E-Pins</h6>
                <div className="income-body">
                  <span className="income-value">{totalPin}</span>
                  <span className="income-icon mdi mdi-menu"></span>
                </div>
              </div>
              <div className="right-img">
                <Image
                  src={dynamicImage("Icons/incomeIcon.png")}
                  alt="plus"
                  className="me-2"
                />
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col xl="12">
                <Row>
                  <Col md="3">
                    <FormGroup>
                      <Label className="">From Date:</Label>
                      <DatePicker
                        className="form-control"
                        selected={fromDate}
                        onChange={(date: any) => setFromDate(date)}
                        dateFormat="dd-MMMM-yyyy"
                        placeholderText="dd-MMMM-yyyy"
                      />
                    </FormGroup>
                  </Col>

                  <Col md="3">
                    <FormGroup>
                      <Label className="">To Date:</Label>
                      <DatePicker
                        className="form-control"
                        selected={toDate}
                        onChange={(date: any) => setToDate(date)}
                        dateFormat="dd-MMMM-yyyy"
                        placeholderText="dd-MMMM-yyyy"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <Label>Search By </Label>
                      <select
                        onChange={(e) => setSearchBy(e.target.value)}
                        name="Title"
                        className=" form-control btn-square form-select"
                      >
                        <option value="PIN">{"Pin No."}</option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <Label>Value</Label>
                    <FormGroup>
                      <input
                        onChange={(e) => setValue(e.target.value)}
                        className="form-control"
                        autoComplete="off"
                        type="text"
                        placeholder="Value"
                        name="Value"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <Label>Status </Label>
                      <select
                        onChange={(e) => setStatus(e.target.value)}
                        name="Status"
                        className=" form-control btn-square form-select"
                      >
                        <option value="Unused">{"Unused"}</option>
                        <option value="Used">{"Used"}</option>
                        <option value="Blocked">{"Blocked"}</option>
                        <option value="All">{"All"}</option>
                      </select>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup>
                      <Label>Package</Label>
                      <select
                        onChange={(e) => {
                          const val = e.target.value;
                          setPackageId(val === "" ? null : parseInt(val, 10));
                        }}
                        value={packageId ?? ""}
                        className="form-control btn-square form-select"
                      >
                        <option value="">All</option>
                        {activePin.length > 0 ? (
                          activePin.map((pin, index) => (
                            <option key={index} value={pin.ProductId}>
                              {pin.ProductName} ({pin.ProductCount})
                            </option>
                          ))
                        ) : (
                          <option disabled>No Packages</option>
                        )}
                      </select>
                    </FormGroup>
                  </Col>

                  <Col
                    md="3"
                    className="d-flex align-items-center justify-content-start pb-2 pb-md-0"
                  >
                    <button
                      onClick={handleSubmit}
                      type="submit"
                      className="btn btn-primary mt-0 mt-md-3"
                    >
                      <IoSearchSharp /> Search
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </form>

          <Col className="mb-3">
            <Card className="mb-3 p-2">
              <div
                className="table-shell"
                style={{
                  height: `calc(100vh - ${heightOffset}px)`,
                  minHeight: 360,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DataTable
                  data={data}
                  columns={columns}
                  pagination={false} // server-side / custom pager
                  highlightOnHover
                  subHeader
                  // subHeaderComponent={subHeader}
                  subHeaderComponent={
                    <>
                      {loading ? (
                        <Col
                          className="d-flex justify-content-center align-items-center"
                          style={{ minHeight: "10px" }}
                        >
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </Col>
                      ) : (
                        ""
                      )}
                      <Row className="p-0 m-0 align-items-center justify-content-between">
                        {data.length > 0 || filterText != "" ? (
                          <Col
                            md={12}
                            className="d-flex align-items-center position-relative"
                          >
                            <IoSearchSharp
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "30px",
                                fontSize: "20px",
                                transform: "translateY(-50%)",
                                color: "#999",
                                pointerEvents: "none",
                              }}
                            />

                            <input
                              className="form-control w-100 ps-5"
                              placeholder="Search value..."
                              value={filterText}
                              onChange={(e) => {
                                setFilterText(e.target.value);
                                setCurrentPage(1);
                                FetchData(1, perPage, e.target.value);
                              }}
                            />
                          </Col>
                        ) : (
                          ""
                        )}
                        {/* {data.length>0 ? (
                    <Col md="auto" className="d-flex mt-2 mt-md-0 align-items-center">
                      <Btn
                        color="primary"
                        onClick={() => exportAndPrintCSV(data)}
                        style={{ marginRight: "10px" }}
                      >
                        <IoMdPrint size={20} /> Print
                      </Btn>
                      <Btn
                        color="primary"
                        onClick={() => exportToExcel(data)}
                      >
                        <PiMicrosoftExcelLogoFill size={20} /> Excel
                      </Btn>
                    </Col>
                    ):'' } */}
                      </Row>
                    </>
                  }
                  subHeaderAlign="right"
                  fixedHeader
                  fixedHeaderScrollHeight="calc(100vh - 220px)" // अपनी layout के हिसाब से adjust
                  persistTableHead
                  responsive
                  dense
                  progressPending={loading} // ✅ सही loader
                  progressComponent={
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  }
                  noDataComponent={<Datanotfound />}
                  customStyles={{
                    headCells: {
                      style: { whiteSpace: "nowrap", fontWeight: 600 },
                    },
                    cells: {
                      style: {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      },
                    },
                    tableWrapper: { style: { overflow: "auto" } },
                  }}
                />
                {data.length > 0 || filterText != "" ? (
                  <CustomPagination
                    currentPage={currentPage}
                    perPage={perPage}
                    totalRows={totalRows}
                    onPageChange={(page: number) => {
                      setCurrentPage(page);
                      // FetchData(page, perPage, filterText);
                    }}
                    onRowsPerPageChange={(newPerPage: number) => {
                      setPerPage(newPerPage);
                      setCurrentPage(1);
                      // FetchData(1, newPerPage, filterText);
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            </Card>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default SearchPinReport;
